import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import useUser from 'Hooks/useUser';
import OrganizationNeedsSetupV2 from "./OrganizationNeedsSetupV2";

const AdminOnboarding = () => {
    const history = useHistory()
    const { isSymphonyAdmin } = useUser();

    useEffect(() => {
        if (!isSymphonyAdmin) {
            history.push('/')
        }
    }, [isSymphonyAdmin])

    return (
        <OrganizationNeedsSetupV2
            title="Admin: Onboard a Team"
        />
    )
}

export default AdminOnboarding